import React, {useContext} from 'react';
import {observer} from 'mobx-react-lite';
import {Main, TemplateHelp} from '../../../patterns';
import {StoreContext} from '../base/root-store';

export const PrivacyPolicyPage = observer((): JSX.Element => {
    const store = useContext(StoreContext).privacyPolicyViewStore;

    return (
        <Main>
            <TemplateHelp content={store.privacyPolicyText}/>
        </Main>
    );
});
